import Service from '@/services/abstract/service'

export default class Scripts extends Service {
  constructor () {
    super()

    this._scriptsRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/ScriptsVendas`
    )
  }

  async getScripts (tipo, ativo = true, empresas, empresasObject) {
    try {
      this._loading.setLoading(true, 'Carregando Scripts')
      let scriptsArr = new Array()

      for (let empresa of empresas) {
        const emp = empresasObject.find(element => element.cnpj === empresa)
        const response = null
        if (tipo !== '') {
          response = await this._scriptsRef
            .where('tipo', '==', tipo)
            .where('ativo', '==', ativo)
            .where('empresas', 'array-contains', empresa)
            .orderBy('ordem', 'asc')
            .get()
        } else {
          response = await this._scriptsRef

            .where('ativo', '==', ativo)
            .where('empresas', 'array-contains', empresa)
            .orderBy('ordem', 'asc')
            .get()
        }

        for (let script of response.docs) {
          scriptsArr.push({
            nomeEmpresa: emp.nome,
            id: script.id,
            ...script.data()
          })
        }
      }

      return Promise.resolve(scriptsArr)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async createScript (params) {
    try {
      const data = {
        descricao: params.descricao,
        conteudo: params.conteudo,
        ativo: params.ativo,
        tipo: params.tipo,
        copy: params.copy,
        empresas: params.empresas,
        ordem: Number.parseInt(params.ordem),
        createdAt: new Date()
      }

      this._loading.setLoading(true, 'Salvando Informações')
      this._scriptsRef.doc().set(data)
      return Promise.resolve({ message: 'Script inserido com sucesso' })
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
  // async obterUltimo(){
  //   try {
  //     // this._scriptsRef.

  //   } catch (error) {

  //   }
  // }

  async updateScript (id, params) {
    try {
      const data = {
        descricao: params.descricao,
        conteudo: params.conteudo,
        ativo: params.ativo,
        tipo: params.tipo,
        copy: params.copy,
        updatedAt: new Date()
      }

      this._loading.setLoading(true, 'Alterando Informações')
      this._scriptsRef.doc(id).update(data)
      return Promise.resolve({ message: 'Script alterado com sucesso' })
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async updateEmpresaScript (id, params) {
    try {
      this._loading.setLoading(true, 'Alterando Informações')
      const response = await this._scriptsRef
        .doc(id)
        .update({ empresas: params })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
